import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IApiResponse } from '../api-response';
import { DataHttpCommonService } from '../data-http-common.service';
import { EndpointUrlConfig } from '../endpoint.config';
import type { IEndpointUrlConfig } from '../endpoint.config';
import { EmailDataHttpService } from './abstract';
import type { IGetMailboxesResult, IAddToFavoritesRequestParams } from './abstract';

@Injectable()
export class EmailDataHttpServiceImpl implements EmailDataHttpService {
	constructor(
		@Inject(EndpointUrlConfig) public readonly config: IEndpointUrlConfig,
		public readonly http: HttpClient,
		public readonly common: DataHttpCommonService
	) {}

	getMailboxes(): Observable<IGetMailboxesResult> {
		const url = this.common.getApiUrl(`emails/mailboxes`);
		return this.http
			.get<IApiResponse<IGetMailboxesResult>>(url, {
				headers: {
					['background-request']: 'true',
				},
			})
			.pipe(map(result => result.data));
	}

	deleteMailBox(mailboxId: number): Observable<any> {
		const url = this.common.getEndpointUrl('/TCWeb.asmx/DeleteMailbox');
		return this.http.post<any>(url, { mailboxId: mailboxId });
	}

	addToFavorites(requestParams: IAddToFavoritesRequestParams) {
		const url = this.common.getEndpointUrl('/TCWeb.asmx/AddToFavourites');
		const request = {
			link: `javascript:void(TCLeftTrees.openSyndicate('?forceURL=Emails%2fEmailList.aspx%3ffolderId%3d${requestParams.folderId}&previewUrl=EmptyPreviewPage.aspx%3ffromEmail%3d1'))`,
			name: requestParams.folderName,
			isJsFunction: true,
			customImagePath: null,
			customImageClass: 'emailTreeMailFolder',
			type: 9,
			linkedObjectId: requestParams.folderId,
			folderId: null,
		};
		return this.http.post<any>(url, request);
	}

	markAllAsRead(folderId: number): Observable<any> {
		const url = this.common.getEndpointUrl('/TCWeb.asmx/EmailMassChangeReadState');
		const request = { emailIds: null, folderId: folderId, fromSearchFolder: false, setRead: true };
		return this.http.post<any>(url, request);
	}

	clearFolder(folderId: number): Observable<any> {
		const url = this.common.getEndpointUrl('/TCWeb.asmx/MassDeleteEmail');
		const request = { emailIds: null, folderId: folderId, fromSearchFolder: false };
		return this.http.post<any>(url, request);
	}
}
